import React, { useEffect } from 'react'
import Drawer from 'react-modern-drawer'
import 'react-modern-drawer/dist/index.css'
import DrawerMenuStyle from './DrawerMenuStyle'
import { useLocation, useNavigate } from 'react-router-dom'
import { AiOutlineUnorderedList } from 'react-icons/ai'
import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { ChevronDown } from 'lucide-react'
import customMainApi from '../../api'
import { main } from '../../store/slices'
import { Spin } from 'antd'

const DrawerMenu = () => {
	const navigate = useNavigate()
	const location = useLocation()
	const dispatch = useDispatch()

	const { setRoleAccess } = main.actions
	const { getMe } = useSelector((state) => state.main)

	const jobTitle = get(getMe, 'U_JobTitle', '')
	const isAdminOrKassir = ['Admin', 'Kassir'].includes(jobTitle)

	const [isOpen, setIsOpen] = React.useState(false)
	const [activeParent, setActiveParent] = React.useState()
	const [activeMenu, setActiveMenu] = React.useState(location.pathname.slice(1))
	const [userAccess, setUserAccess] = React.useState({})
	const [loadingAccess, setLoadingAccess] = React.useState(true)

	useEffect(() => {
		fetchUserAccess()
	}, [])

	const fetchUserAccess = async () => {
		setLoadingAccess(true)
		const data = await customMainApi
			.get('U_JOBTITLE', {
				params: {
					$filter: `Code eq '${get(getMe, 'U_JobTitle', '')}'`,
				},
			})
			.then((res) => {
				const resData = JSON.parse(res.data).value
				const data = resData.length > 0 ? resData[0] : {}
				dispatch(setRoleAccess(data))
				return data
			})
			.finally(() => setLoadingAccess(false))

		console.log('Data =', data)

		setUserAccess(data)
		setLoadingAccess(false)
	}

	const menusList = [
		{
			title: 'Главная страница',
			navigate: 'dashboard',
			accessKey: 'U_ModulMain',
		},
		{
			title: 'Главная страница Ундирүвчи',
			navigate: 'undiruvchi-dashboard',
			accessKey: 'U_MenuCollectorDashboard',
		},
		{ title: 'Продажи', navigate: 'sales', accessKey: 'U_MenuSales' },

		{
			title: 'Аккаунт защиты',
			navigate: 'icloud',
			accessKey: 'U_MenuICloud',
		},

		{
			title: 'Список конфискованных устройств',
			navigate: 'removedPhones',
			accessKey: 'U_MenuItemMIB',
		},
		{ title: 'Задачи', navigate: 'task', accessKey: 'U_MenuTask' },
		{ title: 'Сборы', navigate: 'recovery', accessKey: 'U_MenuCollector' },

		{
			title: 'Курс доллара',
			navigate: 'dollarCourse',
			accessKey: 'U_MenuUSDRate',
		},
		{ title: 'Клиенты', navigate: 'clients', accessKey: 'U_MenuCustomer' },
		{ title: 'SMS', navigate: 'sms', accessKey: 'U_MenuSMS' },
		{
			title: 'Касса ',
			key: 'cash',
			accessKey: 'U_ModulBank',
			children: [
				{
					title: 'Информация о кассе',
					navigate: 'info-about-cash',
					accessKey: 'U_MenuKassa',
				},
				{
					title: 'Исходящий платеж',
					navigate: 'outgoing-payment',
					accessKey: 'U_MenuOutgoingPayment',
				},

				{
					title: 'Перемещения в сейф',
					navigate: 'get-money',
					accessKey: 'U_MenuCashSend',
				},
				// {
				// 	title: 'Принят деньги на кассу без предупреждение',
				// 	navigate: 'journal-entries',
				// },
				{
					title: 'Отправить деньги из кассы',
					navigate: 'sent-draft-journal-entries',
					accessKey: 'U_MenuCashSendRequest',
				},
				{
					title: 'Принять деньги на кассу ',
					navigate: 'received-draft-journal-entries',
					accessKey: 'U_MenuCashSendConfirm',
				},
			],
		},

		{
			title: 'Перемещение товаров',
			navigate: 'inventory-transfer ',
			accessKey: 'U_MenuTransfer',
		},
		{ title: 'Покупки ', navigate: 'purchases', accessKey: 'U_MenuIPurchase' },

		{
			title: 'Cклад остатка',
			navigate: 'reports',
			accessKey: 'U_MenuStock',
		},
		{
			title: 'Добавить продукт',
			navigate: 'add-product',
			accessKey: 'U_AddItemMasterData',
		},
		{
			title: 'Конвертатция ',
			navigate: 'convert',
			accessKey: 'U_MenuConvert',
		},
		{ title: 'Настройки ', navigate: 'settings', accessKey: 'U_MenuISetup' },

		{
			title: 'Черный список',
			navigate: 'black-list-clients',
			accessKey: 'U_MenuCustomerBlock',
		},
		...(isAdminOrKassir
			? [
					{ title: 'Жалобы', navigate: 'complaints' },
					{ title: 'Кэшбэк история', navigate: 'ledger' },
					{ title: 'Отчёт по кэшбэку', navigate: 'cashback-summary' },
					{ title: 'Филиалы и рассрочка', navigate: 'nasiya-settings' },
				]
			: []),
	]
	const handleActive = (n) => {
		menusList.map((v) => {
			if (v.key === n) {
				setActiveParent(n)
				v.children.map((child) => {
					if (child.navigate === n) {
						setActiveMenu(n)
					}
				})
			} else if (v.navigate === n) {
				setActiveMenu(n)
			}
		})
	}

	const toggleDrawer = () => {
		setIsOpen((prevState) => !prevState)
	}

	const goToScreen = (n) => {
		if (n === 'login') {
			navigate(`/${n}`, { replace: true })
		} else {
			navigate(`/${n}`)
		}
	}

	function handleParent(key) {
		if (key === activeParent) {
			setActiveParent(null)
		} else {
			setActiveParent(key)
		}
	}

	useEffect(() => {
		menusList.map((v) => {
			if (v.children) {
				v.children.map((child) => {
					if (child.navigate === activeMenu) {
						setActiveParent(v.key)
					}
				})
			}
		})
	}, [])

	const filterMenusByAccess = (menus, permissions) => {
		return menus
			.map((menu) => {
				// Handle children first
				if (menu.children) {
					const filteredChildren = filterMenusByAccess(
						menu.children,
						permissions,
					)

					// Show parent only if children exist
					if (filteredChildren.length > 0) {
						return { ...menu, children: filteredChildren }
					}
					return null
				}

				// Menu without accessKey (like Logout)
				if (!menu.accessKey) return menu

				// Check permission
				return permissions[menu.accessKey] === 'Y' ? menu : null
			})
			.filter(Boolean)
	}

	const filteredMenus = filterMenusByAccess(menusList, userAccess)

	return (
		<DrawerMenuStyle>
			<button onClick={toggleDrawer} className="listBtn">
				<AiOutlineUnorderedList />
			</button>
			<Drawer open={isOpen} onClose={toggleDrawer} direction="left">
				<div className="drawer overflow-y-auto">
					<p className="menuTitle">Меню</p>
					{loadingAccess && (
						<Spin
							spinning={loadingAccess}
							tip="Загрузка..."
							className="w-full flex items-center justify-center h-full"
						></Spin>
					)}

					{filteredMenus.map((v, i) => {
						if (v.children)
							return (
								<div>
									<button
										className={
											v.key === activeParent
												? 'btn flex gap-2 items-center justify-center'
												: 'btn flex gap-2 items-center justify-center'
										}
										onClick={() => handleParent(v.key)}
									>
										{v.title}{' '}
										{activeParent !== v.key ? (
											'>'
										) : (
											<ChevronDown size={18} className="mt-1" />
										)}
									</button>
									{activeParent === v.key &&
										v.children.map((child, i) => (
											<button
												key={i}
												className={
													activeMenu === child.navigate
														? 'btnActive ml-5 !w-[90%]'
														: 'btn !bg-green-200 !border-black !border-2 ml-5 !w-[90%]'
												}
												onClick={() => {
													goToScreen(child.navigate)
													handleActive(child.navigate)
													handleActive(v.key)
												}}
											>
												{child.title}
											</button>
										))}
								</div>
							)
						else
							return (
								<button
									key={i}
									className={v.navigate === activeMenu ? 'btnActive' : 'btn'}
									onClick={() => {
										goToScreen(v.navigate)
										handleActive(v.navigate)
									}}
								>
									<span> {v.title}</span>
								</button>
							)
					})}
				</div>
			</Drawer>
		</DrawerMenuStyle>
	)
}

export default DrawerMenu
